import { IncidentSummarySchema } from "../incidentSummary";
import { CommentsContainer, MarkdownContainer, TextContainer } from "../incidentSummary.styled";
import Markdown from 'markdown-to-jsx'
import IncidentComments from "../incidentComments";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { Paper } from "@mui/material";
import { UserClaims } from "core/contexts/auth/auth";

export interface MalwareChatTableSummaryProps {
    incidentSummary: IncidentSummarySchema | undefined;
    user: UserClaims | null;
}

export const MalwareChatTableSummary = ({
    incidentSummary,
    user
  }: MalwareChatTableSummaryProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    // If incidentSummary is undefined, return a fallback or null to avoid rendering errors
    if (!incidentSummary) {
        return <p>No incident summary available.</p>;  // Or any fallback UI
    }

    return (
        <>
            <span>
                <span className="d-flex flex-row align-content-center mt-3">
                    <p>Event:</p>
                    <strong className="m-0 ps-2">{incidentSummary.event}</strong>
                </span>
                <span className="d-flex flex-row mt-3">
                    <p className="pe-2">Summary: </p>
                    <MarkdownContainer>
                        <Markdown>
                            {incidentSummary.event_summary || ""}
                        </Markdown>
                    </MarkdownContainer>
                </span>
            </span>

            <MarkdownContainer>
                <Markdown className="mb-3">
                    {incidentSummary.code_analysis || ""}
                </Markdown>
            </MarkdownContainer>

            {/* <MarkdownContainer>
                <Markdown className="mb-3">
                    {incidentSummary.file_analysis || ""}
                </Markdown>
            </MarkdownContainer>
            
            <MarkdownContainer>
                <Markdown className="mb-3">
                    {incidentSummary.slim_output_answers || ""}
                </Markdown>
            </MarkdownContainer>
            
            <MarkdownContainer>
                <Markdown className="mb-3">
                    {incidentSummary.completed_code_review || ""}
                </Markdown>
            </MarkdownContainer> */}

            <CommentsContainer>
                <IncidentComments 
                    t={t} theme={theme} 
                    initialComments={incidentSummary.comments || []} 
                    incidentId={incidentSummary.id || ""} 
                    user={user} 
                />
            </CommentsContainer>
            
            <TextContainer container spacing={2} className="d-flex flex-column">
                <strong className="mb-3" style={{fontSize: theme.font.large}}>{t("INCIDENTS_PAGE.AI_DISCLAMER_TITLE")}:</strong>
                <p className="word-break"><strong>{t("INCIDENTS_PAGE.PLEASE_NOTE")}: </strong> 
                The information provided here has been generated by AI and, as such, may contain inaccuracies or &#39;hallucinations&#39;. We advise users to verify the accuracy of the information before relying on it for any critical decisions or actions.
                </p>
            </TextContainer>
        </>
    );
};
